<!--components\Accesorios\IconosRepresentativos.vue-->
<template>
    <section class="pb-[0rem] md:pb-[1rem] pt-6 md:pt-[3rem] justify-items-center">
        <div class="w-full px-4 md:px-6 max-w-[76rem]">

            <!-- Versión Desktop: Grid de 3 columnas -->
            <div class="hidden md:flex justify-center">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-8 w-[80%]">
                    <PanelTipo6 v-for="(item, index) in funcionamientoData" :key="index" 
                        :clase_custom="item.clase_custom" 
                        :imagenfuente="item.imagenfuente"
                        :clase_imagen="item.clase_imagen" 
                        :clasediv="item.clasediv" 
                        :clase_titulo="item.clase_titulo" 
                        :textotitulo="item.textotitulo" 
                        :texto="item.texto" 
                        :clase_texto="item.clase_texto" 
                    />
                </div>
            </div>

            <!-- Versión Mobile: Carrusel con slots -->
            <div class="block md:hidden px-4">
                <Carrusel
                    :data="funcionamientoData"
                    :itemsPorPagina="itemsPorPagina"
                    :ClaseSlide="ClaseSlide"
                    :autoplay="true" 
                    :autoplayInterval="4000" 
                    :bucle="true"
                    :habilitarBotonesNav="false"
                    :motrarPuntos="true"

                    PadreDotClass="pt-2"
                    customDotClass="w-3 h-3"
                    customActiveDotClass="bg-ROJO_LEON w-6" 
                    customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2"

                    customBotonesNavClass="p-2 bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 shadow-md"
                    customIconClass="text-current w-5 h-5" 
                    customPrevPosition="left-0 -translate-x-3"
                    customNextPosition="right-0 translate-x-3">
                    
                    <!-- Slot para renderizar -->
                    <template #contenido="{ items }">
                        <PanelTipo6 v-for="(item, index) in items" :key="index" 
                            :clase_custom="item.clase_custom" 
                            :imagenfuente="item.imagenfuente"
                            :clase_imagen="item.clase_imagen" 
                            :clasediv="item.clasediv" 
                            :clase_titulo="item.clase_titulo" 
                            :textotitulo="item.textotitulo" 
                            :texto="item.texto" 
                            :clase_texto="item.clase_texto" 
                        />
                    </template>
                </Carrusel>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'

import PanelTipo6 from '~/components/Paneles/PanelTipo6.vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'

const ClaseSlide = ref('flex flex-col gap-5 h-[auto] md:h-[32rem] p-2')
const itemsPorPagina = ref(1)

// Data de los pasos del funcionamiento
const funcionamientoData = ref([
    {
        clase_custom: 'w-full rounded-xl bg-ROJO_LEON flex-col md:flex-col px-[1rem] md:px-[1rem] py-[1rem] md:py-[1rem] h-[auto] gap-[1rem] md:gap-[1rem]',
        imagenfuente: '/img/accesorios/copa_blanca.png', 
        clase_imagen: 'flex flex-col w-[50%] md:w-[50%] h-auto rounded-xl', 
        clasediv: 'w-full h-auto',
        clase_titulo: '',
        textotitulo: '' ,
        texto: 'Las mejores marcas',
        clase_texto: 'text-lg text-white text-center font-bold'
    },
    {
        clase_custom: 'w-full rounded-xl bg-ROJO_LEON flex-col md:flex-col px-[1rem] md:px-[1rem] py-[1rem] md:py-[1rem] h-[auto] gap-[1rem] md:gap-[1rem]',
        imagenfuente: '/img/accesorios/caja_blanca.png', 
        clase_imagen: 'flex flex-col w-[50%] md:w-[50%] h-auto rounded-xl', 
        clasediv: 'w-full h-auto',
        clase_titulo: '',
        textotitulo: '' ,
        texto: 'Stock Permanente',
        clase_texto: 'text-lg text-white text-center font-bold'
    },
    {
        clase_custom: 'w-full rounded-xl bg-ROJO_LEON flex-col md:flex-col px-[1rem] md:px-[1rem] py-[1rem] md:py-[1rem] h-[auto] gap-[1rem] md:gap-[1rem]',
        imagenfuente: '/img/accesorios/medalla_blanca.png', 
        clase_imagen: 'flex flex-col w-[50%] md:w-[50%] h-auto rounded-xl', 
        clasediv: 'w-full h-auto',
        clase_titulo: '',
        textotitulo: '' ,
        texto: 'Garantía',
        clase_texto: 'text-lg text-white text-center font-bold'
    },
    {
        clase_custom: 'w-full rounded-xl bg-ROJO_LEON flex-col md:flex-col px-[1rem] md:px-[1rem] py-[1rem] md:py-[1rem] h-[auto] gap-[1rem] md:gap-[1rem]',
        imagenfuente: '/img/accesorios/auto_blanco.png', 
        clase_imagen: 'flex flex-col w-[50%] md:w-[50%] h-auto rounded-xl', 
        clasediv: 'w-full h-auto',
        clase_titulo: '',
        textotitulo: '' ,
        texto: 'Servicio Express',
        clase_texto: 'text-lg text-white text-center font-bold'
    }
])
</script>